<app-metric-card
  [title]="cardTitle"
  [currentValue]="tprData().value"
  [suffix]="'%'"
  [hidePrevious]="true"
  [hideComparison]="true"
  [showGauge]="false"
  [gaugeHeight]="'90px'"
  [isLoading]="isLoading()"
></app-metric-card>
